import Table from 'antd/es/table';
import { useStore } from 'effector-react';
import { Collapse } from 'antd';
import { $userInfo } from '../../models/authModel/index.js';

const status_colors = {
  active: '#05CD99',
  inactive: '#EE5D50',
};

const dataSource = [
  {
    id: '1',
    name: 'Представление, защита прав и законных интересов субъектов предпринимательства в государственных органах Республики Казахстан, а также международных организациях и зарубежных государствах в соответствии с Законом РК «О Национальной палате предпринимателей Республики Казахстан», иными нормативными правовыми актами и уставом НПП РК; ',
  },
  {
    id: '2',
    name: 'представление интересов предпринимательства в Правительстве Республики Казахстан, Парламенте Республики Казахстан и других государственных органах; ',
  },
  {
    id: '3',
    name: 'принятие участия в разработке нормативных правовых актов, затрагивающих интересы субъектов предпринимательства, за исключением проектов нормативных правовых актов центральных и местных исполнительных органов, а также акимов, предусматривающих принятие решений об установлении (отмене) карантинной зоны с введением карантинного режима на соответствующей территории, об установлении (снятии) карантина и (или) ограничительных мероприятий в случаях, предусмотренных законодательством Республики Казахстан в области ветеринарии, а также объявление чрезвычайной ситуации природного и техногенного характера; ',
  },
  {
    id: '4',
    name: 'осуществление обязательной экспертизы концепций проектов законов, проектов законодательных и иных нормативных правовых актов, затрагивающих интересы субъектов частного предпринимательства, за исключением проектов нормативных правовых актов центральных и местных исполнительных органов, а также акимов, предусматривающих принятие решений об установлении (отмене) карантинной зоны с введением карантинного режима на соответствующей территории, об установлении (снятии) карантина и (или) ограничительных мероприятий в случаях, предусмотренных законодательством Республики Казахстан в области ветеринарии, а также объявление чрезвычайной ситуации природного и техногенного характера; ',
  },
  {
    id: '5',
    name: 'осуществление разработки и внесение в Правительство Республики Казахстан предложений по вопросам передачи в конкурентную среду функций центральных и (или) местных исполнительных органов в сфере предпринимательской деятельности, за исключением функций государственного регулирования деятельности финансовых организаций и финансового рынка; ',
  },
  {
    id: '6',
    name: 'Пункты 3,4,5 изложены в соответствии с решением Съезда от 29.10.2020 г. Протокол №7 ',
  },
  {
    id: '7',
    name: 'принятие участия в работе коллегиальных консультативно совещательных органов при центральных и местных государственных органах, создаваемых по вопросам, затрагивающим права и обязанности предпринимателей; ',
  },
  {
    id: '8',
    name: 'проведение общественных слушаний по вопросам предпринимательства; ',
  },
  {
    id: '9',
    name: 'осуществление общественного мониторинга; ',
  },
  {
    id: '10',
    name: 'внесение в Правительство Республики Казахстан предложения по совершенствованию деятельности центральных и местных государственных органов по вопросам предпринимательства; ',
  },
  {
    id: '11',
    name: 'участие в проведении оценки эффективности корпоративного управления в контролируемых государством акционерных обществах; ',
  },
  {
    id: '12',
    name: 'осуществление на регулярной основе подготовки и ведения независимого рейтинга «Деловой климат»; ',
  },
  {
    id: '13',
    name: 'обеспечение информацией общество и государство о состоянии предпринимательской активности путем подготовки и опубликования ежегодного национального доклада о состоянии предпринимательской активности в Республике Казахстан; ',
  },
  {
    id: '14',
    name: 'проведение на регулярной основе сбора, обобщения и анализа информации о соблюдении государственными органами и (или) государственными служащими прав и законных интересов субъектов предпринимательства; ',
  },
  {
    id: '15',
    name: 'принятие участия в управлении специальными экономическими зонами; ',
  },
  {
    id: '16',
    name: 'по согласованию с уполномоченным органом в области транспорта и коммуникаций принятие участия в обеспечении строительства (реконструкции), функционирования (эксплуатации) объектов инфраструктуры пунктов пропуска Республики Казахстан, в том числе сервисной (таможенной) инфраструктуры, включая их оборудование и техническое оснащение (за исключением специального оборудования государственных контрольных органов), а также содержание и ремонт зданий, помещений и сооружений, необходимых для организации в указанных пунктах пропуска пограничного, таможенного видов контроля, путем привлечения инвестиций; ',
  },
  {
    id: '17',
    name: 'осуществление анализа и обобщения практики корпоративного управления; ',
  },
  {
    id: '18',
    name: 'организация и проведение конкурса на соискание премии Президента Республики Казахстан «Алтын сапа» и конкурс-выставку «Лучший товар Казахстана; ',
  },
  {
    id: '19',
    name: 'осуществление функции оператора нефинансовой поддержки физических лиц, претендующих на занятие предпринимательской деятельностью, и субъектов предпринимательства, включая сервисную поддержку предпринимателей, предусмотренные документами Системы государственного планирования Республики Казахстан;',
  },
  {
    id: '20',
    name: 'принятие участия в разработке стандартов и технических регламентов и обеспечение их соблюдения предпринимателями в соответствии с законодательством Республики Казахстан; ',
  },
  {
    id: '21',
    name: 'принятие участия в разработке современных стандартов таможенной инфраструктуры в целях улучшения оказания услуг в сфере таможенного дела в соответствии с законодательством Республики Казахстан; ',
  },
  {
    id: '22',
    name: 'принятие участия в разработке уполномоченными государственными органами национальных топливно-энергетических балансов, реализации и потреблении сырья и товаров в отраслях экономики; ',
  },
  {
    id: '23',
    name: 'создание и осуществление поддержки, администрирования и развития единого интернет-портала для субъектов предпринимательства; ',
  },
  {
    id: '24',
    name: 'в порядке, предусмотренном нормативными правовыми актами, принятие участия в осуществлении мер по поддержке отечественного производства и повышению доли местного содержания в закупках; ',
  },
  {
    id: '25',
    name: 'принятие участия в осуществлении мониторинга исполнения контрактных обязательств недропользователями в части местного содержания в товарах, работах, услугах, кадрах и социального развития территорий; ',
  },
  {
    id: '26',
    name: 'ведение рейтинга поставщиков товаров, работ, услуг; ',
  },
  {
    id: '27',
    name: 'анализ действующей правовой базы и условий, связанных с участием Республики в международных организациях и подготовка отчетов, рекомендаций по совершенствованию казахстанского законодательства; ',
  },
  {
    id: '27-1',
    name: 'принятие участия в разработке отраслевых рамок квалификаций, утверждение профессиональных стандартов; ',
  },
  {
    id: '28',
    name: 'Пункт 27 изложен в соответствии с решением Съезда от 29.10.2020 г. Протокол №7',
  },
  {
    id: '29',
    name: 'утверждение единых и (или) межотраслевых типовых норм и нормативов по труду для всех сфер деятельности;',
  },
  {
    id: '30',
    name: 'Пункт 27-1 дополнен в соответствии с решением Съезда от 29.10.2020 г. Протокол №7 ',
  },
  {
    id: '31',
    name: 'принятие участия в государственной аттестации организаций технического и профессионального образования, за исключением автономных организаций образования; ',
  },
  {
    id: '32',
    name: 'принятие участия в работе консультативно-совещательного органа по лицензированию образовательной деятельности юридических лиц, реализующих образовательные учебные программы технического и профессионального образования; ',
  },
  {
    id: '33',
    name: 'принятие участия в коллегиальных органах управления государственных организаций технического и профессионального образования по согласованию, за исключением автономных организаций образования; ',
  },
  {
    id: '34',
    name: 'внесение предложения для формирования и размещения государственного заказа на подготовку кадров в соответствии с потребностями рынка труда отраслей экономики; ',
  },
  {
    id: '35',
    name: 'принятие участия в деятельности отраслевых и региональных советов по развитию технического и профессионального образования и подготовке кадров; ',
  },
  {
    id: '36',
    name: 'принятие участия в разработке учебно-методических материалов, в том числе государственных общеобязательных стандартов образования, образовательных учебных программ и планов технического и профессионального образования; ',
  },
  {
    id: '36-1',
    name: 'проведение мониторинга потребности субъектов предпринимательства в профессиональных кадрах; ',
  },
  {
    id: '37',
    name: 'разработка и реализация мероприятий по содействию трудоустройству специалистов; ',
  },
  {
    id: '38',
    name: 'создание учебных центров по профессиональной подготовке, переподготовке, повышению квалификации и присвоению квалификации по профессиям (специальностям) технического и обслуживающего труда; ',
  },
  {
    id: '39',
    name: 'формирование и ведение реестра организаций образования по профессиональной подготовке, переподготовке, повышению квалификации и присвоению квалификации по профессиям (специальностям) технического и обслуживающего труда; Пункт 36-1 дополнен в соответствии с решением Съезда от 29.10.2020 г. Протокол №7 ',
  },
  {
    id: '40',
    name: 'принятие участия в сборе и анализе информации по исполнению недропользователями обязательств по расходам, направляемым на обучение, повышение квалификации и переподготовку работников, являющихся гражданами Республики Казахстан, задействованных при исполнении контракта, или обучение граждан Республики Казахстан по перечню специальностей, согласованному с уполномоченным органом; ',
  },
  {
    id: '41',
    name: 'совместно с зарубежными организациями образование деловых советов и иных консультативно-совещательных органов в соответствии с законодательством Республики Казахстан и положениями международных договоров; ',
  },
  {
    id: '41-1',
    name: 'ведение реестра проводимых международных выставок и ярмарок, национальных и региональных выставок и ярмарок, проводимых в Республике Казахстан, а также международных выставок за рубежом, в которых принимает участие Республика Казахстан; ',
  },
  {
    id: '42',
    name: 'хранение копии сертификата о происхождении товара и документов, подтверждающих происхождение товара, по перечню, утверждаемому государственным органом, осуществляющим государственное регулирование в области технического регулирования, не менее трех лет со дня выдачи сертификата о происхождении товара; ',
  },
  {
    id: '43',
    name: 'не менее одного раза в год направление в уполномоченный орган в сфере таможенного дела и государственный орган, осуществляющий государственное регулирование в области технического регулирования, образцы оттисков печатей, подписей лиц, уполномоченных заверять сертификаты о происхождении товаров; ',
  },
  {
    id: '44',
    name: 'определение порядка ведения и ведение реестра субъектов предпринимательства, участников внешнеэкономической деятельности, финансово-экономическое положение которых позволяет определить уровень их надежности как партнеров для предпринимательской деятельности, составленного по согласованию с указанными лицами; Пункт 41-1 дополнен в соответствии с решением Съезда от 29.10.2020 г. Протокол №7 ',
  },
  {
    id: '45',
    name: 'организация изготовления бланков сертификатов о происхождении товара в соответствии с формами бланков, утвержденными уполномоченным органом в области технического регулирования; ',
  },
  {
    id: '46',
    name: 'проведение альтернативного анализа регуляторного воздействия в случае несогласия с выводами анализа регуляторного воздейст0вия, проведенного регулирующими государственными органами; ',
  },
];

const collapses = [
  {
    label: 'Представительство и защита бизнеса',
    key: '1',
    children: (
      <ul>
        <li>
          Представление интересов бизнес-сообщества в Правительстве, Парламенте,
          акиматах
        </li>
        <li>Защита прав в госорганах, судах и международных структурах</li>
        <li>
          Участие в разработке законов и обязательная экспертиза проектов НПА
        </li>
        <li>Внесение предложений по реформе госполитики и законодательства</li>
      </ul>
    ),
  },
  {
    label: 'Аналитика и деловой климат',
    key: '2',
    children: (
      <ul>
        <li>Подготовка национального доклада о состоянии бизнеса</li>
        <li>Ведение рейтинга “Деловой климат”</li>
        <li>Мониторинг соблюдения прав предпринимателей госслужащими</li>
        <li>Анализ корпоративного управления в квазигосударственном секторе</li>
      </ul>
    ),
  },
  {
    label: 'Инфраструктура и нефинансовая поддержка',
    key: '3',
    children: (
      <ul>
        <li>Поддержка создания инфраструктуры пунктов пропуска и СЭЗ</li>
        <li>Сервисная и методическая поддержка предпринимателей</li>
        <li>Участие в реализации госпрограмм поддержки МСБ</li>
        <li>Создание и развитие порталов и цифровых платформ для бизнеса</li>
      </ul>
    ),
  },
  {
    label: 'Образование и кадры',
    key: '4',
    children: (
      <ul>
        <li>Участие в формировании госзаказа на подготовку кадров</li>
        <li>Разработка стандартов и учебных программ</li>
        <li>Мониторинг и анализ потребности в кадрах</li>
        <li>Создание учебных центров и содействие в трудоустройстве</li>
      </ul>
    ),
  },
  {
    label: 'Международная деятельность и экспорт',
    key: '5',
    children: (
      <ul>
        <li>Представление интересов на международных выставках</li>
        <li>Хранение и подтверждение сертификатов о происхождении товара</li>
        <li>Разработка и экспертиза международных договоров</li>
        <li>Ведение реестра надёжных ВЭД-партнёров</li>
      </ul>
    ),
  },
  {
    label: 'Производство, стандарты и локализация',
    key: '6',
    children: (
      <ul>
        <li>Поддержка местного содержания и казахстанских производителей</li>
        <li>Участие в разработке стандартов и регламентов</li>
        <li>Мониторинг исполнения контрактов недропользователями</li>
        <li>Проведение оценки эффективности корпоративного управления</li>
      </ul>
    ),
  },
  {
    label: 'Экспертиза и регулирование',
    key: '7',
    children: (
      <ul>
        <li>Альтернативная экспертиза проектов госрегулирования</li>
        <li>Участие в совещательных органах при министерствах</li>
        <li>Ведение реестров, рейтингов и типовых норм</li>
        <li>
          Поддержка инициатив по передаче функций госорганов в бизнес-среду
        </li>
      </ul>
    ),
  },
];

function FreeServicesTable() {
  const userInfo = useStore($userInfo);
  // const columns = [
  //   {
  //     title: '№',
  //     dataIndex: 'id',
  //     key: 'free_id',
  //   },
  //   {
  //     title: 'Виды бесплатных услуг',
  //     dataIndex: 'name',
  //     key: 'free_name',
  //     render: (name, record) => {
  //       return {
  //         props: {
  //           style: {
  //             background: userInfo.mmf_payed
  //               ? status_colors.active
  //               : status_colors.inactive,
  //           },
  //         },
  //         children: <div>{name}</div>,
  //       };
  //     },
  //   },
  // ];

  return <Collapse items={collapses} />;

  // return <Table columns={columns} dataSource={dataSource} pagination={false} />;
}

export default FreeServicesTable;
